export const environment = {
  baseUrl: 'https://back.recette4aws.tefal.com',
  apiUrl: '/rest/v2',
  baseSiteId: 'WMF-RU'
};
